import React, { useEffect, useState } from 'react'
import { ReactComponent as Scanner } from "assets/img/svg/scanner.svg"
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput"
import { customStyle, getDropdowns, inputAmountStyle, labelSyle, numberDecimalLimitRegex, paymentModeMapping, setUpdatedAdjustmentAmount, 
    // validatePaymentMode 
} from "./constant"
import AButton from "views/pages/manage/common/form-fields-mui/AButton"
import { useGetCollectPaymentContext } from "../../context"
import Error from '../errorHandlimg/Error'
import { adjustmentValidation } from '../validations/paymentModeValidation'
import { getAdjustmentAmount } from '../../apis'
import { getConditionalCOllectSaveButton } from './common'
import { formattedPrice } from '../../utils'
const AdjustmentView = ({heading, isEditForm,isReceiptEdit=false, isView=false,contextValue,rowId,handleClose})=>{
    const [errorMgs, setErrorMgs] = useState()
    const [adjustmentAmount,setAdjustmentAmount] = useState()

    const {
        setModifyPaymentModeData,
        paymentModeFormHandler,
        studentBasicDetails, 
        currentPaymentMode,
        paymentModeForm,
        selectedChargesAmount,
        bankMasterId,
        setBalanceAmount,
        setBalanceMode,
        setloader,
        setCollectPayment,
        collectPayment,
        balanceAmount,
        validatePaymentMode,
        disableAmountField
    } = contextValue;
    const validatePayment=async()=>{
        const error=await adjustmentValidation(paymentModeForm,collectPayment,currentPaymentMode,balanceAmount,adjustmentAmount)
        setErrorMgs(error)
       if(!error)
        {
           const isOk= await validatePaymentMode(studentBasicDetails,currentPaymentMode,paymentModeForm,selectedChargesAmount,bankMasterId,'',setBalanceAmount,setBalanceMode,setloader,setCollectPayment,balanceAmount,collectPayment)
           if(isOk){
            isReceiptEdit===true && setModifyPaymentModeData((prev) => ({ ...prev, [rowId]: paymentModeForm }))
            isReceiptEdit&& handleClose(true)
           }

        }
}
useEffect(()=>{
    setloader(true);
    getAdjustmentAmount(studentBasicDetails,paymentModeMapping[currentPaymentMode])
      .then((data) => {
        if(data?.code === 200) {
            const amount = setUpdatedAdjustmentAmount(collectPayment,paymentModeMapping[currentPaymentMode],data?.data)
            setAdjustmentAmount(amount);}
        setloader(false);
      })
      .catch((error) => {
        console.log(error)
        setloader(false);
      });
   },[heading])

   const disabled=!paymentModeForm?.paidAmount
   const rightSideError={
    CMP:'CMPR Available',
    SDJ:'SDJ Available',
    ADJ:'Adjustment Available'
   }
   console.log(adjustmentAmount, isView, isReceiptEdit, "loggin")
    return(
        <>
        {!isView&&!isReceiptEdit&&<div className=" d-flex justify-content-between align-items-center mt-2">
                <span className="large-bold color-dark">{heading}</span>
                <div className="d-flex justify-content-between align-items-center" style={{gap:'16px'}}><span>{rightSideError[paymentModeMapping[currentPaymentMode]]}</span> <span className="large-bold  mr-1">{formattedPrice(adjustmentAmount)}</span> </div>
        </div>
        }
        <div>
            <AInput
                label="Enter Amount"
                labelStyle={labelSyle}
                value={paymentModeForm?.paidAmount}
                customIcon={
                    <div className='large-semi-bold'>&#8377;</div>
                  }
                  customIconStyle={customStyle}
                  handler={(value) => {
                    if (
                        !value || parseFloat(value) > 0
                    ) {
                        paymentModeFormHandler('paidAmount',value)
                    }

                }}
                placeholder="Enter amount"
                style={inputAmountStyle}
                disabled={(adjustmentAmount==0?true:false)||isView||isReceiptEdit===true || disableAmountField} 
                regex={numberDecimalLimitRegex(10, 2)}
            />
        </div>
        {getConditionalCOllectSaveButton(disabled,
                paymentModeForm,
                validatePayment,
                isReceiptEdit,
                isEditForm,
                isView,
                setModifyPaymentModeData,
                rowId,
                handleClose)}
        <Error errorMgs={errorMgs}/>
    </>
    )
}
export default AdjustmentView